import { db } from '../config/firebase';
import { doc, getDoc } from "firebase/firestore";

/**
 * Fetches the ultra passwords from a specific Firestore document.
 * Assumes a collection 'ultrapass' with a document 'passultra' containing 'password' and optionally 'password2' fields.
 * @returns {Promise<{password: string, password2?: string}>} Object containing the passwords.
 * @throws Will throw an error if the Firestore operation fails, the document/field is missing, or password is not a string.
 */
export const getUltraPassword = async () => {
  const docRef = doc(db, "ultrapass", "passultra");
  try {
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      // Validate that the password field exists and is a non-empty string
      if (data && typeof data.password === 'string' && data.password.length > 0) {
        const result = { password: data.password };
        
        // Check if there's a second password
        if (data.password2 && typeof data.password2 === 'string' && data.password2.length > 0) {
          result.password2 = data.password2;
        }
        
        return result;
      }
      console.error("Firestore 'ultrapass/passultra' document: 'password' field is missing, not a string, or empty.");
      throw new Error("Password configuration error. Please contact an administrator.");
    }
    console.error("Firestore document 'ultrapass/passultra' not found.");
    throw new Error("Password configuration not found. Please contact an administrator.");
  } catch (error) {
    // Log the original error if it's not one of the custom errors thrown above
    if (error.message !== "Password configuration error. Please contact an administrator." && 
        error.message !== "Password configuration not found. Please contact an administrator.") {
      console.error("Error fetching ultra password from Firestore:", error);
    }
    // Re-throw a generic error or the already specific error
    throw new Error(error.message || "Failed to retrieve secret password. Please try again.");
  }
};
